export enum WaitingFlags {
  None = 1 << 0,
  EvaluaCreate = 1 << 1,
  CreatePPRInvoice = 1 << 2,
  ExpenseFamilyTypeCreate = 1 << 3,
  ErreurPPRInvoice = 1 << 4
}
